const MOBILE_NAV_SELECTOR = '.lyckd-mobile-nav__details';
const DRAWER_TRANSITION_DURATION = 540;
const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function getToggle(details) {
  const toggle = details.querySelector(':scope > .lyckd-mobile-nav__toggle');
  return toggle instanceof HTMLElement ? toggle : null;
}

function setToggleLabel(details, isOpen) {
  const toggle = getToggle(details);
  if (toggle) toggle.setAttribute('aria-label', isOpen ? 'Close navigation menu' : 'Open navigation menu');
}

function openMobileNavigation(details) {
  if (details.dataset.state === 'open' || details.dataset.state === 'opening') return;

  details.setAttribute('open', '');
  details.dataset.state = 'opening';
  setToggleLabel(details, true);

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      if (details.dataset.state === 'opening') details.dataset.state = 'open';
    });
  });
}

function closeMobileNavigation(details, restoreFocus = true) {
  if (!details.open || details.dataset.state === 'closing') return;

  const panel = details.querySelector(':scope > .lyckd-mobile-nav__panel');
  details.dataset.state = 'closing';
  setToggleLabel(details, false);

  const finishClosing = () => {
    if (details.dataset.state !== 'closing') return;

    details.removeAttribute('open');
    delete details.dataset.state;

    if (restoreFocus) getToggle(details)?.focus({ preventScroll: true });
  };

  if (reducedMotionMediaQuery.matches || !(panel instanceof HTMLElement)) {
    finishClosing();
    return;
  }

  const onTransitionEnd = (event) => {
    if (event.target !== panel || event.propertyName !== 'transform') return;
    panel.removeEventListener('transitionend', onTransitionEnd);
    finishClosing();
  };

  panel.addEventListener('transitionend', onTransitionEnd);
  window.setTimeout(() => {
    panel.removeEventListener('transitionend', onTransitionEnd);
    finishClosing();
  }, DRAWER_TRANSITION_DURATION);
}

document.addEventListener('pointerdown', (event) => {
  if (!(event.target instanceof Element)) return;
  if (event.target.closest('.lyckd-mobile-nav__backdrop')) event.preventDefault();
});

function preventBackgroundScroll(event) {
  if (!(event.target instanceof Element)) return;
  if (!document.querySelector(`${MOBILE_NAV_SELECTOR}[open]`)) return;
  if (event.target.closest('.lyckd-mobile-nav__panel')) return;
  event.preventDefault();
}

document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });
document.addEventListener('wheel', preventBackgroundScroll, { passive: false });

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const toggle = event.target.closest('.lyckd-mobile-nav__toggle');
  if (toggle instanceof HTMLElement) {
    const details = toggle.closest(MOBILE_NAV_SELECTOR);
    if (!(details instanceof HTMLDetailsElement)) return;

    event.preventDefault();
    if (details.open) {
      closeMobileNavigation(details, false);
    } else {
      openMobileNavigation(details);
      if (event.detail > 0) toggle.blur();
    }
    return;
  }

  const backdrop = event.target.closest('.lyckd-mobile-nav__backdrop');
  if (!(backdrop instanceof HTMLElement)) return;

  const details = backdrop.closest(MOBILE_NAV_SELECTOR);
  if (details instanceof HTMLDetailsElement) closeMobileNavigation(details, event.detail === 0);
});

document.addEventListener('keydown', (event) => {
  const details = document.querySelector(`${MOBILE_NAV_SELECTOR}[open]`);
  if (!(details instanceof HTMLDetailsElement)) return;

  if (event.key === 'Escape') {
    closeMobileNavigation(details);
    return;
  }

  if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest('.lyckd-mobile-nav__panel')) event.preventDefault();
  }
});
